<template>
    <el-dialog
        class="keydata-driver-delegate-enable-dialog"
        title="提示"
        width="780px"
        :visible.sync="visible"
        :before-close="close">
        <div class="driver-info">
            <div>以下司机的手机号码和委派函的签署手机号不一致，如确认启用，需重新发起委派函签署，待签署完毕后司机即可启用。</div>
            <div>司机：{{ driverNames }}</div>
        </div>
        <div>
            <el-form ref="formRef" :model="formData" :rules="formRules" label-width="130px" label-position="left">
                <!-- 委派函 -->
                <div class="delegate-wrapper">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="选择签署人" prop="stamperCode" class="stamperCode">
                                <el-input readonly v-model="formData.stamperName" placeholder="选择签署人">
                                    <template v-slot:append>
                                        <el-button icon="el-icon-s-custom" @click="detaliSearch(stamperParams)"></el-button>
                                    </template>
                                    <template v-slot:suffix>
                                        <i class="el-input__icon el-icon-circle-close" v-if="formData.stamperName" @click="resetAdvanceValue"></i>
                                    </template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="签署人手机" prop="stamperMobile" style="margin-right: 15px">
                                <el-input readonly v-model="formData.stamperMobile" placeholder="请输入签署人手机号码" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="委派开始时间" prop="delegateStartTime" class="delegateStartTime" style="margin-right: 15px">
                                <el-date-picker
                                    value-format="yyyy-MM-dd"
                                    v-model="formData.delegateStartTime"
                                    type="date"
                                    placeholder="请选择委派开始时间"
                                    style="width: 100%"
                                    :picker-options="pickerOptionsDelegateStartTime"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="委派结束时间" prop="delegateEndTime" class="delegateEndTime" style="margin-right: 15px">
                                <el-date-picker
                                value-format="yyyy-MM-dd"
                                v-model="formData.delegateEndTime"
                                type="date"
                                placeholder="请选择委派结束时间"
                                style="width: 100%"
                                :picker-options="pickerOptionsDelegateEndTime"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="签署方式" prop="pushType" class="push-type-form-item">
                                <MSelect
                                    :optionNum="'SRM_SUPPLIER_DELEGATE_TYPE'"
                                    :value="formData.pushType"
                                    @input="val => handleSelect(val, 'pushType')"
                                ></MSelect>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
        </div>
        <!-- 高级弹窗组件 -->
        <advance-dialog ref="advanceDialog" @confirm="detaliSearchSure"></advance-dialog>
        <span slot="footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="submit">发起委派函签署</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { pushSignAndEnable } from '../../../../../../api/register/driver.js';
import { PUSH_TYPE } from '../../../../../../constant/constant.js'
import { stamperParams } from './newUploadVersion/config.js'
import { pickerOptionsDelegateStartDate, pickOptionsDelegateEndDate } from './newUploadVersion/util.js'
import MSelect from '@/components/lots/otpSelect2';
import AdvanceDialog from '@/components/lots/otpAdvanceDialog';

const INIT_FORM = {
    stamperName: '', // 签署人姓名
    stamperCode: '', // 签署人编码
    stamperMobile: '', // 签署人手机号码
    delegateStartTime: '', // 委派函起始日期
    delegateEndTime: '', // 委派函结束日期
    pushType: PUSH_TYPE.ALONE, // 签署方式
}

export default {
    components: { MSelect, AdvanceDialog },
    props: {
        supplierTab: {
            type: Object,
            default: () => { supplierCode: '' }
        }
    },
    data() {
        return {
            visible: false,
            loading: false,
            formData: { ...INIT_FORM },
            formRules: {
                delegateStartTime: [{ required: true, message: '请选择委派开始时间', trigger: ['blur', 'change'] }],
                delegateEndTime: [{ required: true, message: '请选择委派结束时间', trigger: ['blur', 'change'] }],
                // 签署人
                stamperCode: [{ required: true, message: '请选择签署人', trigger: ['change'] }],
                // 签署人手机号码
                stamperMobile: [{ required: true, message: '请输入签署人手机号码', trigger: ['change'] }],
                // 签署方式
                pushType: [{ required: true, message: '请选择签署方式', trigger: ['change'] }],
            },
            pickerOptionsDelegateStartTime: pickerOptionsDelegateStartDate(this),
            pickerOptionsDelegateEndTime: pickOptionsDelegateEndDate(this),
            stamperParams,
            relationIds: [],
            driverNames: '',
        }
    },
    methods: {
        open(driverList) {
            this.visible = true
            this.relationIds = driverList.map(item => item.relationId)
            this.driverNames = driverList.map(item => item.driverName).join('、')
        },
        close() {
            this.formData = { ...INIT_FORM }
            this.relationIds = []
            this.driverNames = ''
            this.$nextTick(() => {
                this.$refs.formRef.clearValidate()
                this.visible = false
            })
        },
        detaliSearch(advanceCascade) {
            const supplierCode = this.supplierTab.supplierCode
            this.$refs.advanceDialog.show(true, advanceCascade, { supplierCode })
        },
        // 选中高级组件值后回调
        detaliSearchSure(data) {
            Object.keys(data).forEach(k => {
                this.$set(this.formData, k, data[k]);
            });
        },
        // 重置高级组件
        resetAdvanceValue() {
            this.formData.stamperCode = ''
            this.formData.stamperName = ''
        },
        submit() {
            this.$refs.formRef.validate().then(valid => {
                this.loading = true
                const params = {
                    relationIdList: this.relationIds,
                    ...this.formData,
                }
                pushSignAndEnable(params).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('启用成功!')
                        this.$emit('submit')
                        this.close()
                    }
                }).finally(() => { this.loading = false })
            }).catch(err => {})
        },
        handleSelect(value, prop) {
            this.formData[prop] = value;
        },
    }
}
</script>
<stype lang="less">
    .keydata-driver-delegate-enable-dialog {
        .driver-info {
            padding: 0 15px;
            div {
                line-height: 25px;
            }
        }

        .el-form-item.delegate {
            padding-left: 15px;
            .el-form-item__label {
                width: 60px!important;
            }
            .el-form-item__content {
                margin-left: 75px!important;
            }
        }
        .el-form-item {
            .el-form-item__label, .el-form-item__content {
                line-height: 28px;
            }
        }
        .delegate-wrapper {
            border: 1px solid #ccc;
            margin: 0 15px 5px 0;
            padding: 20px 0 0;
            .el-col-12 {
                padding-left: 15px;
                padding-right: 15px;
            }
            .el-form-item.stamperCode {
                // width: 350px;
                .el-input {
                    .el-input__inner {
                        cursor: pointer;
                    }
                }
            }
            .el-form-item__content .el-input-group {
                vertical-align: middle;
            }
        }

        .push-type-form-item {
            .otp-select {
                width: 190.5px;
            }
        }
    }
</stype>
